import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export const Section = ({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) => {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={`py-16 md:py-24 ${className}`} data-id="element-260">
      <div className="max-w-5xl mx-auto px-6 md:px-8" data-id="element-261">{children}</div>
    </motion.section>;
};